<template>
  <v-layout :tinyFooter="true">
    <vue-element-loading :active="loading || $checkingAuthState" />
    <div v-if="isPharmacyList && !$checkingAuthState">
      <ProductSheetBase :product="product">
        <template v-slot:purchase-info>
          <div class="return mt-4 pt-3">
            <b-link :to="productSheetRoute">
              {{ $t("product_sheet_view.return") }}
            </b-link>
          </div>
        </template>
      </ProductSheetBase>
      <ProductPharmacyList :product="product" class="pt-4 pb-0" />
    </div>
    <div v-else>
      <ProductSheet :product="product" />
      <VRelatedDrugsSlider :product="product" class="pt-4 pb-0" />
    </div>
  </v-layout>
</template>


<script>
import { mapGetters } from "vuex";

import VLayout from "@/layouts/Default";
import ProductSheet from "@/components/ProductSheet";
import ProductSheetBase from "@/components/ProductSheetBase";
import VRelatedDrugsSlider from "@/components/VRelatedDrugsSlider";
import ProductPharmacyList from "@/components/ProductPharmacyList";

export default {
  components: {
    VLayout,
    ProductSheet,
    ProductSheetBase,
    VRelatedDrugsSlider,
    ProductPharmacyList,
  },
  metaInfo() {
    return {
      meta: this.metaTags,
    };
  },
  serverPrefetch () {
    return this.loadProduct();
  },
  data() {
    return {
      namePage: "%s - ",
      loading: false,
    };
  },
  beforeMount: function() {
    if (!this.product || this.product.uuid !== this.$route.params.drugUuid) {
      if (!this.$checkingAuthState) {
        this.loadProduct();
      }
    }
  },
  computed: {
    ...mapGetters("drugs", ["getCategoryPath"]),
    isPharmacyList () {
      return (this.$route.name === "product_pharmacies");
    },
    productSheetRoute() {
      return {
        name: "product_sheet",
        params: {
          drugUuid: this.$route.params.drugUuid,
        },
      };
    },
    product () {
      return this.$store.state.drugs.currentDrug;
    },
    metaTags () {
      if (!this.product) {
        return [];
      }
      const socialMetaTags = this.$getSocialSharingMetaInfo({
        title: this.product.description,
        description: this.product.description,
        image: this.product.picture.picture,
      });
      return socialMetaTags.concat(this.product.metatags);
    },
  },
  watch: {
    $checkingAuthState(checking) {
      if (!checking) {
        this.loadProduct();
      }
    },
    $route () {
      this.loadProduct();
    },
  },
  methods: {
    loadProduct() {
      this.loading = true;
      const drugUuid = this.$route.params.drugUuid;
      return this.$store
        .dispatch("drugs/LOAD_PHDRUG", {
          dUuid: drugUuid,
        })
        .then(
          () => {
            if (this.product) {
              this.loadBreadcrumb();
            }
            this.loading = false;
          },
          err => {
            if (err.response && err.response.status === 404) {
              this.$router.push({ name: "not_found" });
              this.loading = false;
            }
            else {
              this.$sentry({ capture: err });
              this.$router.push({ name: "fallback-error-page" });
              this.loading = false;
            }
          }
        );
    },
    loadBreadcrumb() {
      var breadcrumb = [
        {
          langkey: "home.breadcrumb",
          route: "home",
        },
      ];

      // Put categories in breadcrumb
      if (this.product.categories.length > 0) {
        var path = this.getCategoryPath(this.product.categories[0].uuid);
        var department = undefined;
        if (path[0]) {
          department = path[0].department;
        }

        for (var i in path) {
          breadcrumb.push({
            langkey: path[i].name,
            route: "product_list",
            params: { listType: department },
            query: { categoryUuid: path[i].uuid },
          });
        }
      }

      // Product name
      breadcrumb.push({
        langkey: this.product.default_description,
        route: this.$route.name,
      });

      // Apply breadcrumb
      try {
        this.$store.dispatch("siteconf/CHANGE_BREADCRUMB", breadcrumb);
      } catch (err) {
        this.$sentry({ capture: err });
      }
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        product_sheet_view: {
          return: "Return to the offer description",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.return {
  border-top: 1px solid $border-color;

  a {
    color: $corp-color2;
    font-weight: bold;
    text-decoration: underline;
  }
}
</style>
